export default __webpack_public_path__ + "locales/lv/SocialAuthWelcomeDialog.json?hash=11a28c2c3bf79b892279c376cef99c88";